module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/home-category-2396-4431ff.svg";